import getSign from '@didi/wsgsig'
import { type, buildUrl, getQuery } from '../utils'

function checkWhiteList(url, whiteList) {
  if (/^\/[^/]/.test(url)) {
    // 转换根路径url（/xx/yy）
    const location = window.location
    url = `${location.protocol}//${location.host}${url}`
  }
  return whiteList.some(item => {
    return item === '*' || (type(item) === 'RegExp' ? item.test(url) : url.indexOf(item) > -1)
  })
}

export default function sign(config) {
  const needEncrypt = config.needEncrypt === undefined
    ? checkWhiteList(config.url, config.signWhiteList || [])
    : config.needEncrypt
  if (!needEncrypt) {
    return config
  }
  // 待签名参数
  const signOptions = {}
  config.url = buildUrl(config.url, config.params, config.paramsSerializer)
  // 拼接到url后，清除params
  config.params = {}
  // 空参数也进行签名
  signOptions.paramsString = getQuery(config.url)
  if (/^post|put$/i.test(config.method) && config.data) {
    const contentType = config.headers['Content-Type']
    const isUrlEncode = /application\/x-www-form-urlencoded/i.test(contentType)
    const isJSON = /application\/json/i.test(contentType)
    // 只处理json & urlencode
    if (isUrlEncode || isJSON) {
      signOptions.bodyString = config.data || ''
      signOptions.contentType = contentType.toLocaleLowerCase()
    }
  }
  //将签名参数追加到params里面
  config.params = {
    wsgsig: getSign(signOptions)
  }

  return config
}
